import Axios from '../baseApi';
export default {
  fetch() {
    return Axios.get(`api-master-data/pig-calendar/v1`);
  },
  fetchByCategory(categoryId) {
    return Axios.get(`api-master-data/pig-calendar/v1/${categoryId}`);
  },
  fetchCurrentAndFuture(categoryId, count) {
    return Axios.get(`api-master-data/pig-calendar/v1/current-and-future/${categoryId}/${count}`);
  },
  fetchLastAndNext(categoryId, last, next) {
    return Axios.get(`api-master-data/pig-calendar/v1/last-and-next/${categoryId}/${last}/${next}`);
  }
}
